import { ContentStateInterface } from '../../../../../../@types/types'
import { DE, parseDecimal } from '../../../../../../i18next/decimal'
import { ParkingSpaceTypeOption } from '../../../../../../@types/dropdown-types'
import { RealEstateGarageInformation } from '../../../../../../@types/real-estate-api-types'

export const garageInformationToApi = (insertionData: ContentStateInterface): RealEstateGarageInformation => ({
  noParkingSpaces: insertionData.noParkingSpaces,
  parkingSpaceRent: parseDecimal(insertionData.parkingSpaceRent, DE),
  parkingSpaceType: insertionData.parkingSpaceType ?? ParkingSpaceTypeOption.NONE,
})
